export * from "./qr-code-design-preview.component";
